"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _scrollbars = require("../util/scrollbars");

var useTableScroll = function useTableScroll(_ref) {
  var inputRef = _ref.inputRef,
      loading = _ref.loading,
      scrollContainerId = _ref.scrollContainerId,
      _ref$resetScrollOnPag = _ref.resetScrollOnPageChange,
      resetScrollOnPageChange = _ref$resetScrollOnPag === void 0 ? false : _ref$resetScrollOnPag,
      onScrollReset = _ref.onScrollReset,
      onScroll = _ref.onScroll,
      _ref$initialScrollPos = _ref.initialScrollPosition,
      initialScrollPosition = _ref$initialScrollPos === void 0 ? 0 : _ref$initialScrollPos;
  var ref = (0, _react.useRef)(null);

  if (inputRef && inputRef.current !== ref.current) {
    // eslint-disable-next-line no-param-reassign
    inputRef.current = ref.current;
  }

  var scrollContainerRef = (0, _react.useRef)(false);
  var executeResetScroll = (0, _react.useCallback)(function () {
    if (!resetScrollOnPageChange) return;
    var scrollContainerNode = scrollContainerRef.current;

    if (scrollContainerNode) {
      if (onScrollReset) onScrollReset(scrollContainerNode);
      scrollContainerNode.scrollTo(0, 0);
    }
  }, [resetScrollOnPageChange, onScrollReset]);
  var handleOnScroll = (0, _react.useCallback)(function (e) {
    if (onScroll) onScroll(e);
  }, [onScroll]);
  (0, _react.useEffect)(function () {
    var tableNode = ref === null || ref === void 0 ? void 0 : ref.current;
    var isReady = !!tableNode && !loading;
    var scrollContainerNode = scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : scrollContainerRef.current; // If the table node ref hasnt been filled, then we cannot get a reference to the scroll parrent
    // If our scroll container ref is empty, then we should quickly calculate it
    // if we cannot calcualte it, we'll set the ref to null indicating that it
    // cannot be found. This would happen in 2 cases
    // 1. If the provided scrollContainerId doesnt exist
    // 2. If there is no scrollable anchestor to the table

    if (isReady && scrollContainerNode === false) {
      if (scrollContainerId) {
        scrollContainerRef.current = document.getElementById(scrollContainerId);
      } else {
        scrollContainerRef.current = (0, _scrollbars.getScrollParent)(tableNode);
      }

      scrollContainerNode = scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : scrollContainerRef.current;

      if (scrollContainerNode && onScroll) {
        scrollContainerNode.scrollTo(0, initialScrollPosition);
      }
    }

    if (scrollContainerNode && onScroll) {
      scrollContainerNode.addEventListener('scroll', handleOnScroll);
    }

    return function () {
      if (scrollContainerNode) {
        scrollContainerNode.removeEventListener('scroll', handleOnScroll);
      }
    };
  });
  return {
    scrollRef: ref,
    executeResetScroll: executeResetScroll
  };
};

var _default = useTableScroll;
exports["default"] = _default;
//# sourceMappingURL=useTableScroll.js.map